import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "../../bootstrap/index.jsx";
import { DATA_TYPE_RATIO } from './IndicatorForm.jsx';
import Help from "../../common/Help.jsx";
import DateInput from "../../common/DateInput.jsx";
import update from "immutability-helper";

const IndicatorMilestoneFormFields = ({
  indicatorMilestones,
  milestonesEnabled,
  dataType,
  denominator,
  projectMilestones,
}) => {
  const [milestones, setMilestones] = useState(indicatorMilestones || [{}]);

  useEffect(() => {
    setMilestones(indicatorMilestones || [{}]);
  }, [indicatorMilestones]);

  const deleteMilestone = (e, idx) => {
    e.preventDefault();

    if (confirm(I18n.t("confirm_delete_intermediate_target"))) {
      setMilestones(
        update(milestones, {
          $splice: [[idx, 1]],
        })
      );
    }
  };

  const addMilestone = (e) => {
    e.preventDefault();

    setMilestones(
      update(milestones, {
        $push: [{}],
      })
    );
  };

  return (
    <>
      {milestones.map((m, i) => {
        const sortOrder = i + 1;
        const lastTarget = milestones.length == sortOrder;
        return (
          <Row key={i} className="form-group">
            <Col size="xs-4">
              {lastTarget ? (
                <>
                  <strong className="indicator-milestone-name">
                    {I18n.t("target_value")}
                  </strong>
                  <Help text={I18n.t("indicator_target_value_help")} />
                </>
              ) : (
                <span className="indicator-milestone-name">
                  {I18n.t("intermediate_target_short", { number: sortOrder })}
                </span>
              )}
            </Col>
            <Col size="xs-4">
              <input
                type="text"
                name={`milestones[${sortOrder}][value]`}
                placeholder={I18n.t("value")}
                className={`form-control ${
                  dataType == DATA_TYPE_RATIO ? "fraction" : ""
                }`}
                defaultValue={m.value}
              />
              {dataType == DATA_TYPE_RATIO && (
                <>
                  <div className="fraction-dash">/</div>
                  <span className="fraction denominator">{denominator}</span>
                </>
              )}
            </Col>
            <Col size="xs-3">
              {milestonesEnabled ? (
                <select
                  name={`milestones[${sortOrder}][project_milestone_id]`}
                  className="form-control"
                  defaultValue={m.project_milestone_id}
                >
                  <option value="">{I18n.t("select_from_list")}</option>
                  {projectMilestones.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </select>
              ) : (
                <DateInput
                  name={`milestones[${sortOrder}][due_date]`}
                  defaultValue={m.due_date}
                  placeholder={I18n.t("due_date")}
                />
              )}
            </Col>
            {lastTarget && milestonesEnabled && (
              <Col size="xs-1">
                <Help text={I18n.t("indicator_milestone_help")} />
              </Col>
            )}
            {!lastTarget && (
              <Col size="xs-1">
                <Button
                  type="danger"
                  className="pull-right small-remove-button"
                  onClick={(e) => deleteMilestone(e, i)}
                >
                  <i className="icon icon-trash" />
                </Button>
              </Col>
            )}
          </Row>
        );
      })}
      <Row className="form-group">
        <Col>
          <Button className="pull-right" onClick={addMilestone}>
            <i className="icon icon-add" /> {I18n.t("add_intermediate_target")}
          </Button>
          <Help
            text={I18n.t("indicator_intermediate_targets_help")}
            className="pull-right"
            style={{ margin: "10px 10px 0 0" }}
          />
        </Col>
      </Row>
    </>
  );
};

export default IndicatorMilestoneFormFields;
